<template>
  <template v-if="msgItem.isme">
    <div v-if="msgItem.send_status == 2" class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div v-else-if="msgItem.send_status === 0">
      <el-popover
        placement="top-start"
        :width="200"
        trigger="hover"
        :content="msgItem.error_msg">
        <template #reference>
          <i class="iconfont icon-Shapex" style="color: red"></i>
        </template>
      </el-popover>
    </div>
  </template>
</template>

<script>
export default {
  name: "MsgSendStatus",
  props: {
    msgItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.lds-ring {
  color: #1c4c5b;
  padding: 5px;
}

.lds-ring,
.lds-ring div {
  box-sizing: border-box;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  margin: 2px;
  border: 2px solid currentColor;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: currentColor transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
